import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import { formatGeolocations } from './helpers'

import { getChoicesGeolocations } from '../../../../modules/actions/choices'
import { choicesGeolocationsLoadingSelector, choicesGeolocationsSelector } from '../../../../modules/selectors/choices'

const CountryOrRegionMultiSelect = ({ isDisabled = false, formik, name, placeholder = 'Add a country or region' }) => {
  const geolocations = useSelector(choicesGeolocationsSelector)
  const geolocationsLoading = useSelector(choicesGeolocationsLoadingSelector)

  const { values, setFieldValue } = formik

  const formattedGeolocations = useMemo(() => formatGeolocations(geolocations), [geolocations])

  return (
    <MultiSelectBox
      placeholder={placeholder}
      name={name}
      setFieldValue={setFieldValue}
      options={formattedGeolocations}
      value={values[name]}
      isLoading={geolocationsLoading}
      searchAction={getChoicesGeolocations}
      // it's possible to select either location list or add country/regions manually
      isDisabled={isDisabled}
    />
  )
}

CountryOrRegionMultiSelect.propTypes = {
  isDisabled: PropTypes.bool,
  formik: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string
}

export default CountryOrRegionMultiSelect
